import { Box, Button, Loader } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useEffect } from 'react'
import { Link, Navigate } from 'react-router-dom'

export const RequestAccessToken = ({ code }: { code: string }) => {
    const { mutate, data, isPending, error } = useMutation<any, any, {code: string}>({
        mutationFn: ({ code }) => axios({
            method: 'POST',
            url: `/api/login?code=${code}`,
        }),
    })

    useEffect(() => {
        mutate({ code })
    }, [])

    if (error) return (
        <div>
            <Box mb="md">
                <Button component={Link} to="/" variant="subtle">Go back</Button>
            </Box>
            <div>Error!</div>
            <code>{JSON.stringify(error.response?.data)}</code>
        </div>
    )

    if (!data || isPending) return (
        <Loader />
    )

    return (
        <Navigate to="/" />
    )
}
